@if (this.userEditModalService.showUserEditAdvancedOption) {
<section [ngClass]="theme.getThemeClass()" class="advanced-option-modal">
  <h3>{{ "typeOfAlert" | translate }}</h3>
  <article class="advanced-options-box">
    <!-- Section for collections -->
    <h5>{{ "_collections" | translate }}</h5>
    <div class="toggle-stack">
      <div class="custom-control custom-switch cs-container">
        <!-- Rounded switch -->
        <label class="switch">
          <input
            type="checkbox"
            [ngModel]="allThingsCollection"
            name="devices"
            (change)="onChangeAllThingsCollection($event)"
          />
          <span class="slider round"></span>
        </label>
      </div>
      <label class="devices-toggle">{{"allDevices" | translate}}</label>
    </div>
    <!-- select for device wanted -->
    @if (!allThingsCollection) {
    <div class="form-group">
      <div class="force-column">
        <a class="select-clear-btn" (click)="this.selectCollection.clearModel();">{{ "clear" | translate }}</a>
        <app-custom-multi-select
          [(ngModel)]="selectedThingsCollection"
          class="form-control ng-select select-collection"
          [multiple]="true"
          (change)="scrollToBottomCollection()"
          [options]="thingOptions"
          bindLabel="label"
          bindValue="value"
          #selectCollection>
        </app-custom-multi-select>
      </div>
    </div>
    }
    <hr>
    <!-- Section for threshold -->
    <h5>{{ "threshold" | translate }}</h5>
    <div class="toggle-stack">
      <div class="custom-control custom-switch cs-container">
        <!-- Rounded switch -->
        <label class="switch">
          <input
            type="checkbox"
            [ngModel]="allThingsThreshold"
            name="devices"
            (change)="onChangeAllThingsThreshold($event)"
          />
          <span class="slider round"></span>
        </label>
      </div>
      <label class="devices-toggle">{{"allDevices" | translate}}</label>
    </div>
    <!-- select for device wanted -->
    @if (!allThingsThreshold) {
    <div class="form-group">
      <div class="force-column">
        <a class="select-clear-btn" (click)="this.selectThreshold.clearModel();">{{ "clear" | translate }}</a>
        <app-custom-multi-select
          [(ngModel)]="selectedThingsThreshold"
          class="form-control ng-select"
          [multiple]="true"
          (change)="scrollToBottomTreshold()"
          [options]="thingOptions"
          bindLabel="label"
          bindValue="value"
          #selectThreshold>
        </app-custom-multi-select>
      </div>
    </div>
    }
    <hr>
    <!-- Section for monthly report -->
    <h5>{{ "monthlyReport" | translate }}</h5>
    <div class="toggle-stack">
      <div class="custom-control custom-switch cs-container">
        <!-- Rounded switch -->
        <label class="switch">
          <input
            type="checkbox"
            [ngModel]="allThingsMonthlyReports"
            name="devices"
            (change)="onChangeAllThingsMonthlyReports($event)"
          />
          <span class="slider round"></span>
        </label>
      </div>
      <label class="devices-toggle">{{"allDevices" | translate}}</label>
    </div>
    <!-- select for device wanted -->
    @if (!allThingsMonthlyReports) {
    <div class="form-group">
      <div class="force-column">
        <a class="select-clear-btn" (click)="this.selectMonthlyReport.clearModel();">{{ "clear" | translate }}</a>
        <app-custom-multi-select
          appendTo="body"
          [(ngModel)]="selectedThingsMonthlyReports"
          class="form-control ng-select"
          [multiple]="true"
          (change)="scrollToBottomMonthlyReports()"
          [options]="thingOptions"
          bindLabel="label"
          bindValue="value"
          #selectMonthlyReport>
        </app-custom-multi-select>
      </div>
    </div>
    }
  </article>


  <nav class="advanced-option-btn-nav">
    <button [ngClass]="theme.getThemeClass()" class="btn" (click)="this.userEditModalService.closeModal()">{{ "iotModalButtonClose" | translate }}</button>
    <button [ngClass]="theme.getThemeClass()" class="btn" (click)="this.saveAdvanceOption()">{{ "loginFNewPasswordBtnConfirmNewPw" | translate }}</button>
  </nav>
</section>
}
